import 'css-chunksrc/client/pages/planzoneMembersPage/resourcesList/styles.scss';export default {
  "scrolledList": "_scrolledList_1nv95_1",
  "resourcesList": "_resourcesList_1nv95_5",
  "item": "_item_1nv95_9"
};